import  { lazy } from 'react';
import Auth from "../../hoc/Auth";

const podListPromise = import("./PodList");
export default  Auth(lazy(() => podListPromise));